import { AxiosRequestConfig, AxiosResponse } from "axios";
import axios, { AxiosInstance } from "axios";
import { ACCOUNT_API_REFRESH_TOKEN } from "shared/constants/api-endpoint";
import { getApiDomain } from "./loading-data";
import { getCurrentCulture } from "./localization";

const accessTokenName = "AccessToken";
const refreshTokenName = "RefreshToken";

export const getToken = () => localStorage.getItem(accessTokenName);
export const removeToken = () => localStorage.removeItem(accessTokenName);
export const setToken = (token?: string) =>
  localStorage.setItem(accessTokenName, token ?? "");
export const getRefreshToken = () => localStorage.getItem(refreshTokenName);
export const removeRefreshToken = () =>
  localStorage.removeItem(refreshTokenName);
export const setRefreshToken = (token?: string) =>
  localStorage.setItem(refreshTokenName, token ?? "");

class ApiClient {
  constructor() {
    this.instance = axios.create({
      baseURL: getApiDomain() ?? "",
    });
    this.requestInterceptor();
    this.reponseInterceptor();
  }

  instance: AxiosInstance;

  private requestInterceptor() {
    this.instance.interceptors.request.use(
      (config) => {
        if (config.headers.protected) {
          const token = getToken();
          config = {
            ...config,
            headers: { ...config?.headers, Authorization: "Bearer " + token },
          };
        }
        return {
          ...config,
          headers: {
            ...config.headers,
            "Accept-Language": getCurrentCulture(),
          },
        };
      },
      (error) => {
        Promise.reject(error);
      }
    );
  }

  private reponseInterceptor() {
    const that = this;
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      async function (error) {
        const originalRequest = error.config;
        if (
          error.response &&
          error.response.status === 401 &&
          !originalRequest.url.endsWith(ACCOUNT_API_REFRESH_TOKEN) &&
          error.config.headers.protected
        ) {
          const refreshToken = getRefreshToken();
          if (refreshToken !== null) {
            try {
              const res = await that.postHttp(
                ACCOUNT_API_REFRESH_TOKEN,
                {
                  token: refreshToken,
                },
                undefined,
                false
              );
              setRefreshToken(res.data.refreshToken);
              setToken(res.data.accessToken);
              return that.instance.request(originalRequest);
            } catch (e) {
            //  removeToken();
             // removeRefreshToken();
              //document.location.href = "/account/login?callback="+document.location.pathname;
              return Promise.reject(error);
            }
          }
         // document.location.href = "/account/login?callback="+document.location.pathname;
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );
  }

  getHttp<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
    withCredentials = true
  ): Promise<R> {
    return this.instance.get<T, R>(url, {
      ...config,
      headers: { protected: withCredentials },
    });
  }

  postHttp<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
    withCredentials = true
  ): Promise<R> {
    return this.instance.post<T, R>(url, data, {
      ...config,
      headers: { protected: withCredentials },
    });
  }

  putHttp<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
    withCredentials = true
  ): Promise<R> {
    return this.instance.put<T, R>(url, data, {
      ...config,
      headers: { protected: withCredentials },
    });
  }

  deleteHttp<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
    withCredentials = true
  ): Promise<R> {
    return this.instance.delete<T, R>(url, {
      ...config,
      headers: { protected: withCredentials },
    });
  }
}

export const apiClient = new ApiClient();
